import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Slide1 from "../../assets/images/banners/hero-banner-1.png";
import Slide2 from "../../assets/images/banners/hero-banner-2.jpg";
import Slide3 from "../../assets/images/banners/hero-banner-3.jpg";

import { Link } from 'react-router-dom'

const ImageSlider = () => {
  let settings = {
    dots: true,
    infinite: true,
    // autoplay: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    // cssEase: "linear",
  };
  return (
    <>
  
      <section className="slider">
        {/* <div className="container"> */}
          <div className="row">
            <div className="col-full">
              <div className="slider-content">
                <Slider {...settings}>
                  <div className="slider-item">
                    <img
                      src={Slide1}
                      alt="women's latest fashion sale"
                      className="banner-img"
                    />
                    <div className="banner-content">
                      <p className="banner-subtitle">Trending item</p>
                      <h2 className="banner-title">
                        Women's latest fashion sale
                      </h2>
                      <p className="banner-text">
                        starting at &#x24; <b>22</b>.00
                      </p>
                      <Link to="/" className="banner-btn">
                        Shop now
                      </Link>
                    </div>
                  </div>
                  <div className="slider-item">
                    <img
                      src={Slide2}
                      alt="modern sunglasses"
                      className="banner-img"
                    />

                    <div className="banner-content">
                      <p className="banner-subtitle">Trending accessories</p>

                      <h2 className="banner-title">Modern sunglasses</h2>

                      <p className="banner-text">
                        starting at &#x24; <b>15</b>.00
                      </p>

                      <Link to="/" className="banner-btn">
                        Shop now
                      </Link>
                    </div>
                  </div>

                  <div className="slider-item">
                    <img
                      src={Slide3}
                      alt="new fashion summer sale"
                      className="banner-img"
                    />

                    <div className="banner-content">
                      <p className="banner-subtitle">Sale Offer</p>

                      <h2 className="banner-title">New fashion summer sale</h2>

                      <p className="banner-text">
                        starting at &#x24; <b>29</b>.99
                      </p>

                      <Link to="/" className="banner-btn">
                        Shop now
                      </Link>
                    </div>
                  </div>
                </Slider>
              </div>
            </div>
          </div>
        {/* </div> */}
      </section>
      {/* </Slider> */}
    </>
  );
};

export default ImageSlider;
